module.exports = __webpack_public_path__ + "img/e173e1b.png";